@if (isLoading) {
  <div class="spinner-wrap">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'MESSAGES.LOADING' | translate }}</span>
    </div>
  </div>
}

<div class="sales-orders-search form-search mb-2">
  <div class="input-search d-flex align-items-center">
    <input
      type="text"
      [value]="searchTerm"
      placeholder="Search..."
      (input)="onSearchChange($any($event.target).value)"
    />
    <span class="search-icon" aria-hidden="true">
      <img src="assets/img/search.svg" alt="" />
    </span>
  </div>
</div>

@if (totalItems > 0) {
  @if (pagedSalesOrders$ | async; as salesOrders) {
    <div class="orders-table-wrapper">
      <table class="table table-sm orders-table">
        <thead>
          <tr>
            <th>{{ 'TABLE_HEADERS.NUMBER' | translate }}</th>
            <th>{{ 'TABLE_HEADERS.CUSTOMER_NUMBER' | translate }}</th>
            <th>{{ 'COMPONENTS.ORGANIZATION_OVERVIEW.SALES_ORDER_DATE' | translate }}</th>
            <th>{{ 'COMPONENTS.ORGANIZATION_OVERVIEW.SALES_POSTING_DATE' | translate }}</th>
            <th>{{ 'COMPONENTS.ORGANIZATION_OVERVIEW.SALES_REQUESTED_DELIVERY_DATE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (order of salesOrders; track $index) {
            <tr>
              <td>
                @if (order.id) {
                  <button
                    type="button"
                    class="order-link"
                    (click)="openSalesOrder(order)"
                  >
                    {{ order.number || notFound }}
                  </button>
                } @else {
                  {{ order.number || notFound }}
                }
              </td>
              <td>{{ order.customerNumber || notFound }}</td>
              <td>{{ (order.orderDate | date: 'yyyy-MM-dd') || notFound }}</td>
              <td>{{ (order.postingDate | date: 'yyyy-MM-dd') || notFound }}</td>
              <td>
                {{ (order.requestedDeliveryDate | date: 'yyyy-MM-dd') || notFound }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <app-paginator
    class="d-flex justify-content-center mt-3 mb-0"
    [totalItems]="totalItems"
    [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onChangePageSize($event)"
  />
} @else if (!isLoading) {
  {{ notFound }}
}
